import type { CustomBlock } from '../types/ProductType';

export const defaultBenefits = [
  'store.products.defaultBenefits.0',
  'store.products.defaultBenefits.1',
  'store.products.defaultBenefits.2',
];

export const defaultCustomBlocks: CustomBlock[] = [
  {
    title: 'store.products.defaultCustomBlocks.0.title',
    content: 'store.products.defaultCustomBlocks.0.content',
    isTranslationKey: true,
  },
  {
    title: 'store.products.defaultCustomBlocks.1.title',
    content: 'store.products.defaultCustomBlocks.1.content',
    isTranslationKey: true,
  },
];
